import { render, staticRenderFns } from "./LandingCarousel.vue?vue&type=template&id=a795ad16&"
import script from "./LandingCarousel.vue?vue&type=script&lang=js&"
export * from "./LandingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./LandingCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports